<template>
  <app-page class="veh-page" fill lean>
    <!-- Aufbau wie die übrigen Tabellenseiten (Kundenwunsch 13.10.2026: „jetzt bitte alle shop seiten überarbeiten“):
         leichter Titel, links die Suche statt der Filterzeile; ohne Filter und Gruppierung „Aktualisieren“ rechts in
         der Werkzeugleiste (Handy: Icon-Knopf im Kopf) -->
    <template v-if="handy" #actions>
      <app-icon-button icon="refresh" label="Aktualisieren" @click="refreshDataGrid" />
    </template>
    <template #toolbar>
      <app-search v-model="searchText" placeholder="In Fahrzeugtypen suchen" @input="onSearchInput" />
    </template>
    <template v-if="!handy" #toolbar-end>
      <app-button icon="refresh" @click="refreshDataGrid">Aktualisieren</app-button>
    </template>
    <!-- Tabelle füllt die Höhe über der Fußleiste (Handy: natürliche Höhe) -->
    <div class="app-grid-fill veh-grid" :class="{ 'veh-grid--auto': handy }">
      <dx-data-grid
        ref="grid"
        :height="gridHeight"
        :columns="columns"
        :data-source="vehicleDataSource"
        :show-borders="false"
        :show-column-lines="false"
        :show-row-lines="true"
        :column-auto-width="true"
        :allow-column-reordering="!gridTouch"
        :allow-column-resizing="!gridTouch"
        :hover-state-enabled="!gridTouch"
        :scrolling="scrolling"
        :element-attr="gridAttr"
        @toolbar-preparing="onToolbarPreparing"
        @content-ready="onContentReady"
      >
        <dx-editing
          refresh-mode="full"
          :allow-adding="false"
          :allow-updating="false"
          :allow-deleting="false"
          mode="batch"
        />

        <!-- Seitenwahl und Blättern in der Fußleiste (AppGridFooter) -->
        <dx-pager :visible="false" />
        <dx-paging :page-size="defaultPageSize" />

        <template #vehicleRatingTemplate="cell">
          <div>
            <v-rating length="5" hover :value="cell.data.data.classification"></v-rating>
          </div>
        </template>
      </dx-data-grid>
    </div>
    <app-grid-footer ref="fuss" :page-sizes="pageSizes">
      <template #summary>
        <span v-if="narrowed"><strong>{{ summaryCount }}</strong> von {{ summaryLoaded }}</span>
        <span v-else><strong>{{ summaryCount }}</strong> {{ summaryNoun }}</span>
      </template>
    </app-grid-footer>
  </app-page>
</template>

<script>
import {
  DxDataGrid,
  DxPaging,
  DxPager,
  DxEditing,
} from "devextreme-vue/data-grid";
import DataGridMixin from "@/mixins/DataGridMixin";
import CustomStore from "devextreme/data/custom_store";
import axios from "axios";
import { formatNumber, plural } from "@/utils/format";

export default {
  components: {
    DxDataGrid,
    DxPager,
    DxPaging,
    DxEditing,
  },
  mixins: [DataGridMixin],
  computed: {
    handy() {
      return !!(this.$dichte && this.$dichte.handy);
    },
    // Handy: AppPage fill wirkt dort nicht, das Grid wächst mit seinen Zeilen; sonst füllt es die Höhe
    gridHeight() {
      return this.handy ? undefined : "100%";
    },
    // Fußleiste: Anzahl nach der Suche, „3 von 12 …“ solange eingeschränkt
    narrowed() {
      return this.summary.count !== this.summary.loaded;
    },
    summaryCount() {
      return formatNumber(this.summary.count);
    },
    summaryLoaded() {
      return formatNumber(this.summary.loaded) + " " + plural(this.summary.loaded, "Fahrzeugtyp", "Fahrzeugtypen");
    },
    summaryNoun() {
      return plural(this.summary.count, "Fahrzeugtyp", "Fahrzeugtypen");
    },
  },
  data() {
    return {
      searchText: "",
      summary: { count: 0, loaded: 0 },
      gridAttr: {},
      columns: [
        {
          dataField: "id",
          caption: "ID",
        },
        {
          dataField: "name",
          caption: "Name",
        },
        {
          dataField: "capacity",
          caption: "Kapazität",
        },
        {
          dataField: "classification",
          caption: "Klassifizierung",
          cellTemplate: "vehicleRatingTemplate",
        },
        {
          dataField: "equipment",
          caption: "Ausstattung",
        },
      ],
      vehicleDataSource: new CustomStore({
        key: ["customer_id", "id"],
        load: () =>
          axios.get(
            `${this.$store.state.baseUrl}vehicle`
          ).then((response) => {
            this._rows = Array.isArray(response.data) ? response.data : [];
            return response;
          }),
        insert: data =>
          axios.post(`${this.$store.state.baseUrl}vehicle`, data),
        update: (keys, data) =>
          axios.put(
            `${this.$store.state.baseUrl}vehicle?id=${keys.id}`,
            data
          ),
        remove: keys =>
          axios.delete(
            `${this.$store.state.baseUrl}vehicle?id=${keys.id}`
          )
      }),
    };
  },
  methods: {
    refreshDataGrid() {
      this.$refs.grid.instance.refresh();
    },
    onSearchInput() {
      this.$refs.grid.instance.searchByText(this.searchText || "");
    },
    // leere DevExtreme-Leiste über dem Kopf ausblenden (sonst zweite Linie über dem Tabellenkopf)
    onToolbarPreparing(e) {
      e.toolbarOptions.items = [];
      e.toolbarOptions.visible = false;
    },
    onContentReady(e) {
      const grid = e.component;
      const count = Math.max(Number(grid.totalCount()) || 0, 0);
      this.summary = { count, loaded: Math.max((this._rows || []).length, count) };
      if (this.$refs.fuss) {
        this.$refs.fuss.update(grid);
      }
    },
  },
};
</script>

<style scoped>
/* Handy: Grid in natürlicher Höhe */
.veh-grid.veh-grid--auto {
  flex: none;
}
</style>
